<template>
  <b-modal
    v-model="visible"
    title="Similar keywords"
    ok-only
    ok-title="Close"
    size="lg"
  >
    <ifac-loader v-if="busy" />

    <div v-else-if="!hasMatches">
      <p class="mb-0 text-muted">No similar or matching keywords were found elsewhere.</p>
    </div>

    <div v-else>
      <b-alert v-if="content.withinTcDuplicate" show variant="warning" class="mb-3">
        This keyword already exists in this technical committee. Save will be rejected until
        duplicates are removed.
      </b-alert>

      <div v-if="content.exactMatches.length" class="mb-3">
        <strong>Exact matches</strong>
        <ul class="mb-0 mt-2">
          <li
            v-for="match in content.exactMatches"
            :key="exactMatchKey(match)"
            class="text-danger font-weight-bold"
          >
            {{ match.name }}
            <span v-if="match.technicalCommitteeLabel" class="text-muted font-weight-normal">
              (TC{{ match.technicalCommitteeLabel }})
            </span>
          </li>
        </ul>
      </div>

      <div v-if="content.similarMatches.length">
        <strong>Similar keywords</strong>
        <ul class="mb-0 mt-2">
          <li
            v-for="match in content.similarMatches"
            :key="similarMatchKey(match)"
            class="text-warning font-weight-bold"
          >
            {{ match.name }}
            <span v-if="match.technicalCommitteeLabel" class="text-muted font-weight-normal">
              (TC{{ match.technicalCommitteeLabel }}, {{ match.similarity }}% similar)
            </span>
            <span v-else class="text-muted font-weight-normal">({{ match.similarity }}% similar)</span>
          </li>
        </ul>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { IfacLoader } from '@ifac/ui';

export default {
  name: 'SimilarKeywordsModal',
  components: {
    IfacLoader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    busy: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => ({
        exactMatches: [],
        similarMatches: [],
        withinTcDuplicate: false,
      }),
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(isVisible) {
        this.$emit('input', isVisible);
      },
    },
    hasMatches() {
      return this.content.exactMatches.length > 0 || this.content.similarMatches.length > 0;
    },
  },
  methods: {
    exactMatchKey(match) {
      return `${match.id || match.name}-${match.technicalCommitteeLabel || 'unknown'}`;
    },
    similarMatchKey(match) {
      return `${match.id || match.name}-${match.similarity}-${match.technicalCommitteeLabel || 'unknown'}`;
    },
  },
};
</script>
